// extracted by mini-css-extract-plugin
module.exports = {"companiesContainer":"companies-module--companiesContainer--UsQio","companiesRow":"companies-module--companiesRow--1rIN4","companyLogo":"companies-module--companyLogo--2u5MA"};